import { Database } from "types/supabase";
import { supabaseClient } from "supabase";

export type UpdateUserParams = {
  uid: Database["public"]["Tables"]["users"]["Row"]["uid"];
  name: Database["public"]["Tables"]["users"]["Row"]["name"];
  email: Database["public"]["Tables"]["users"]["Row"]["email"];
  preferred_language: Database["public"]["Tables"]["users"]["Row"]["preferred_language"];
};

export const updateUser = async ({
  uid,
  name,
  email,
  preferred_language,
}: UpdateUserParams) => {
  const updatedUser = {
    name,
    email,
    preferred_language,
  };

  const { error } = await supabaseClient
    .from("users")
    .update(updatedUser)
    .eq("uid", uid);

  if (error) {
    throw error;
  }

  return updatedUser;
};
